import React from "react"
import IdentityProvider from "./src/context/identity"
import AuthWrapper from './src/components/Authentication/AuthWrapper';

export const wrapRootElement = ({ element }) => (
  <IdentityProvider>
    <AuthWrapper>
      {element}
    </AuthWrapper>
  </IdentityProvider>
)
